import { getClipList } from '@/services/meetingApi'
const floating = {
  state: () => ({
    layoutType: null,
    clipList: null,
    isRequestVideoType: null,
    requestSaveBlob: null,
  }),
  mutations: {
    // 워크스페이스 정보 설정
    setLayoutType(state, layoutType) {
      state.layoutType = layoutType
    },
    setClipList(state, clipList) {
      state.clipList = clipList
    },
    setIsRequestVideoType(state, isRequestVideoType) {
      state.isRequestVideoType = isRequestVideoType
    },
    setRequestSaveBlob(state, requestSaveBlob) {
      state.requestSaveBlob = requestSaveBlob
    },
  },
  actions: {
    // 클립 리스트 로드
    async getClipList(mtId) {
      try {
        let result = await getClipList(this, mtId)
        if (result.statusCode === '200') {
          this.clipList = result.body
          // this.selectClip(this.clipList[0])
        } else {
          throw new Error('Clip List Error')
        }
      } catch (error) {
        console.log(error.response.status, error.response.data)
      }
    },
    setIsRequestVideoType({ commit }, isRequestVideoType) {
      commit('setIsRequestVideoType', isRequestVideoType)
    },
    setRequestSaveBlob({ commit }, requestSaveBlob) {
      commit('setRequestSaveBlob', requestSaveBlob)
    },
  },
  getters: {
    // 워크스페이스 정보
    getLayoutType(state) {
      return state.layoutType
    },
    getClipList(state) {
      return state.clipList
    },
    isRequestVideoType(state) {
      return state.isRequestVideoType
    },
    requestSaveBlob(state) {
      return state.requestSaveBlob
    },
  },
}

export default floating
